(() => {
  function initialize(scope=document){
    scope.querySelectorAll('[data-lds-finder]').forEach(root=>{
      if(root.dataset.initialized)return;
      root.dataset.initialized='true';
      const buttons=[...root.querySelectorAll('button[data-interest]')];
      const cards=[...root.querySelectorAll('[data-lds-gift]')];
      const budget=root.querySelector('[data-lds-budget]');
      const status=root.querySelector('[data-lds-status]');
      const empty=root.querySelector('[data-lds-empty]');
      const browse=root.querySelector('[data-lds-browse]');
      let active=buttons[0];
      function render(){
        const key=active.dataset.interest;
        const cap=budget.value==='all'?Infinity:Number(budget.value);
        let count=0;
        cards.forEach(card=>{
          const interestMatch=key==='all'?card.dataset.default==='true':card.dataset.interest===key;
          const show=interestMatch&&Number(card.dataset.price)<=cap;
          card.hidden=!show;if(show)count++;
        });
        empty.hidden=count!==0;
        status.textContent=count+' '+root.dataset.resultLabel+' · '+active.textContent.trim()+(Number.isFinite(cap)?' · '+budget.selectedOptions[0].textContent:'');
        browse.href=active.dataset.url||buttons[0].dataset.url;
        browse.firstElementChild.textContent=active.dataset.browse||buttons[0].dataset.browse;
        buttons.forEach(button=>button.setAttribute('aria-pressed',String(button===active)));
      }
      buttons.forEach(button=>button.addEventListener('click',()=>{active=button;render();}));
      budget.addEventListener('change',render);
      root.querySelector('[data-lds-controls]').hidden=false;
      render();
    });
    if(!matchMedia('(prefers-reduced-motion: reduce)').matches&&'IntersectionObserver'in window){
      const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.remove('waiting');observer.unobserve(e.target);}}),{threshold:.08});
      scope.querySelectorAll('.lds-holiday .reveal:not([data-lds-observed])').forEach(e=>{e.dataset.ldsObserved='true';e.classList.add('waiting');observer.observe(e);});
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize());else initialize();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
